import React, { useState, useEffect } from "react";
import axios from "axios";

import { getUser, getIdToken } from "../../../utils/storage";

const Others = (props) => {
  const {
    client,
    setToast,
    filterPeriod,
    filterSentiment,
    toggleSource,
    sources,
  } = props;

  const user = getUser(),
    idToken = getIdToken();

  const [othersSources, setOthersSources] = useState({
    totalSources: 0,
    sources: [],
  });

  const url = `${
    client.clientRef === "12a3c24d-8782-4e40-bc1f-c8abb8e431c7"
      ? "https://us-central1-versus-prod.cloudfunctions.net/versus_v2_prod_get_others_mentions_sources"
      : process.env.REACT_APP_API_BASE_URL +
        "/versus_v2_get_others_mentions_sources"
  }`;

  useEffect(() => {
    axios
      .post(
        url,
        {
          clientRef: client.clientRef,
          uid: user.uid,
          idToken,
          period: filterPeriod,
          sentiment: filterSentiment,
        },
        { headers: { "content-type": "application/json" } }
      )
      .then((result) => {
        if (result.status === 200) {
          const totalSources = result.data.totalSources;
          const sources = result.data.sources;

          setOthersSources({ totalSources, sources });
        }
      })
      .catch((error) => {
        console.log("Error obtaining others mentions sources", error.message);
        setToast({
          show: true,
          type: "warning",
          message:
            "We had problems retrieving others mentions sources. Please refresh",
        });
      });
  }, [
    client.clientRef,
    filterPeriod,
    filterSentiment,
    idToken,
    setToast,
    url,
    user.uid,
  ]);

  return (
    <div
      className="column padded-left rel"
      style={{
        opacity:
          sources.categories.length === 0 ||
          sources.categories.includes("others")
            ? 1
            : 0.2,
      }}
    >
      <h3
        className="card-title"
        data-tooltip={
          sources.categories.includes("others")
            ? "Clear filter by Other sources"
            : "Filter by Other sources"
        }
        onClick={() =>
          toggleSource(
            null,
            "others",
            othersSources.sources.map((src) => src.source)
          )
        }
      >
        Micro Blogs{" "}
        <span className="data small">{othersSources.totalSources}</span>
      </h3>
      <div className="source-container">
        {othersSources.sources.map((source, i) => (
          <span
            data-tooltip={
              sources.others.includes(source.source)
                ? `Clear filter by ${source.source}`
                : `Filter by ${source.source}`
            }
            className="link-block"
            key={i}
          >
            <div
              className="bar-container has-cover"
              style={{
                cursor: "pointer",
                opacity:
                  sources.others.length === 0 ||
                  sources.others.includes(source.source)
                    ? 1
                    : 0.2,
              }}
              onClick={() => toggleSource(source.source, "others")}
            >
              <div className="medium-text nudge-right">{source.source}</div>
              <div className="data tiny nudge-left">{source.total}</div>
              <div className="measure-bar tall cover">
                <div
                  className="metric brand-1"
                  style={{
                    width: `${
                      (source.total / othersSources.totalSources) * 100
                    }%`,
                    height: "7.99219px",
                  }}
                ></div>
              </div>
            </div>
          </span>
        ))}
        {/* <div className="hider-2 s h" style={{ opacity: 0 }}></div> */}
      </div>
    </div>
  );
};

export default Others;
